import { buildModelManager } from "../builder.js";
const DefaultStudentFeedbackHistorySelection = {
  __typename: true,
  id: true,
  cohort: true,
  createdAt: true,
  documentationType: true,
  feedbackCategory: true,
  feedbackDate: true,
  feedbackEmbedding: true,
  feedbackText: { markdown: true, truncatedHTML: true },
  improvementAreas: true,
  institution: true,
  instructorReviewed: true,
  isRecurringIssue: true,
  progressionStatus: true,
  relatedFeedbackIds: true,
  reviewedAt: true,
  reviewedById: true,
  searchableContent: { markdown: true, truncatedHTML: true },
  severity: true,
  sourceRecordId: true,
  specificIssues: true,
  strengthsNoted: true,
  studentId: true,
  studentNotified: true,
  updatedAt: true
};
const modelApiIdentifier = "studentFeedbackHistory";
const pluralModelApiIdentifier = "studentFeedbackHistories";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultStudentFeedbackHistorySelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultStudentFeedbackHistorySelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultStudentFeedbackHistorySelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultStudentFeedbackHistorySelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultStudentFeedbackHistorySelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultStudentFeedbackHistorySelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultStudentFeedbackHistorySelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createStudentFeedbackHistory",
    operationReturnType: "CreateStudentFeedbackHistory",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      studentFeedbackHistory: { required: false, type: "CreateStudentFeedbackHistoryInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultStudentFeedbackHistorySelection
  },
  {
    type: "action",
    operationName: "bulkCreateStudentFeedbackHistories",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateStudentFeedbackHistoriesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultStudentFeedbackHistorySelection
  },
  {
    type: "action",
    operationName: "updateStudentFeedbackHistory",
    operationReturnType: "UpdateStudentFeedbackHistory",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      studentFeedbackHistory: { required: false, type: "UpdateStudentFeedbackHistoryInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultStudentFeedbackHistorySelection
  },
  {
    type: "action",
    operationName: "bulkUpdateStudentFeedbackHistories",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateStudentFeedbackHistoriesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultStudentFeedbackHistorySelection
  },
  {
    type: "action",
    operationName: "deleteStudentFeedbackHistory",
    operationReturnType: "DeleteStudentFeedbackHistory",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteStudentFeedbackHistories",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertStudentFeedbackHistory",
    operationReturnType: "UpsertStudentFeedbackHistory",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      studentFeedbackHistory: { required: false, type: "UpsertStudentFeedbackHistoryInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateStudentFeedbackHistoryResult": { hasReturnType: false },
      "... on UpdateStudentFeedbackHistoryResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultStudentFeedbackHistorySelection
  },
  {
    type: "action",
    operationName: "bulkUpsertStudentFeedbackHistories",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertStudentFeedbackHistoriesInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultStudentFeedbackHistorySelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "studentFeedbackHistoryGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const StudentFeedbackHistoryManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultStudentFeedbackHistorySelection,
  operations
);
export {
  DefaultStudentFeedbackHistorySelection,
  StudentFeedbackHistoryManager
};
//# sourceMappingURL=StudentFeedbackHistory.js.map
